import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, IconButton, useMediaQuery, useTheme, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';

import { getUser } from '../../../../../store/selector/auth.selector';
import ContentSettingsMenu from './content-settings-menu';
import { PropsElement } from '../../../../interfaces/children.interface';
import AvatarLogo from '../../../../assets/images/avatar.png';
import AdminAvatarLogo from '../../../../assets/images/admin-avatar.png';

const styles = {
  wrapper: (isSideNavOpen: boolean, isMobile: boolean, paddingLeft: string) => ({
    width: '100%',
    transition: 'all .7s ease',
    paddingLeft: isMobile ? 0 : `${paddingLeft}`,
    overflowY: isSideNavOpen && isMobile ? 'hidden' : 'auto',
    minHeight: '100vh',
    height: 'auto',
  }),

  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'space-between',
    height: '3.75rem',
    borderBottom: '0.0625rem solid #00000010',
    color: '#2C3333',
    background: '#ffffff',
  },

  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },

  headerRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
  },

  moduleContent: {
    background: '#f8f9fc',
    height: 'calc(100% - 3.75rem)',
    padding: '2rem 1rem',
  },
};

const Content = ({ content, isSideNavOpen, toggleSideNav }: PropsElement) => {
  const user = useSelector(getUser);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    isTablet && setAnchorEl(null);
  });

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box
      data-testid='wrapper'
      sx={styles.wrapper(isSideNavOpen, isMobile, isSideNavOpen ? '16.25rem' : '0')}
    >
      <Box sx={styles.headerWrapper}>
        <Box sx={styles.headerLeft}>
          <IconButton data-testid='toggle-sidebar' onClick={toggleSideNav} sx={{ mr: '1rem' }}>
            <MenuIcon sx={{ fontSize: '1.25rem' }} />
          </IconButton>

          <Typography sx={{ fontSize: { sm: '1.25rem', xs: '1rem' } }}>
            ONLINE HR CLEARANCE
          </Typography>
        </Box>

        {!isTablet && (
          <Box sx={styles.headerRight}>
            <Typography variant='inherit' sx={{ fontSize: '0.75rem' }}>
              {user?.email}
            </Typography>

            {/* <Box
              component='img'
              src={user.is_hr ? AdminAvatarLogo : AvatarLogo}
              sx={{
                width: '2rem',
                height: '2rem',
                borderRadius: '50%',
                background: 'gray',
                overflow: 'visible',
              }}
            /> */}

            <Box
              sx={{
                width: '2rem',
                height: '2rem',
                borderRadius: '50%',
                background: 'white',
                border: '1px solid #dbdbdb',
                overflow: 'visible',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography sx={{ fontSize: '1rem' }}>
                {user?.email.charAt(0).toUpperCase()}
              </Typography>
            </Box>

            <Divider orientation='vertical' variant='middle' flexItem />

            <IconButton onClick={handleClick}>
              <SettingsIcon sx={{ fontSize: '1.20rem', color: anchorEl && '#02004D' }} />
            </IconButton>
          </Box>
        )}
      </Box>

      <Box sx={styles.moduleContent}>{content}</Box>

      <ContentSettingsMenu
        open={open}
        handleClose={setAnchorEl.bind(this, null)}
        anchorEl={anchorEl}
      />
    </Box>
  );
};

export default Content;
